export const mixinDialog = {
    data() {
        return {
            // 弹窗是否显示
            isDialog: false
        };
    },
    methods: {
        // 设置弹窗是否隐藏
        // v treu 隐藏，false 显示
        // dialogName 弹窗v-model默认为dialog
        setDialogHidden(v, dialogName = 'isDialog') {
            this[dialogName] = !v;
        },
        // 关闭弹窗
        // dialogName 弹窗v-model默认为dialog
        hiddenDialog(dialogName = 'isDialog') {
            this.setDialogHidden(true, dialogName);
        },
        // 显示弹窗
        // dialogName 弹窗v-model默认为dialog
        showDialog(dialogName = 'isDialog') {
            this.setDialogHidden(false, dialogName);
        }
    }
}